/**
* @name: menu-li-menu
* @author: weiyong
* @date: 2025-05-19 22:34
* @description：menu-li-menu
* @update: 2025-05-19 22:34
*/
<template>
  <div  class="menu-li-menu">
    <template v-for="sonItem in item.children">
      <menu-li-record    @click="selActiveOneMenu(sonItem)" :item="sonItem"/>
    </template>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "menu-li-menu",
});
</script>

<script lang="ts" setup>
import MenuLiRecord from "@/layouts/layoutFrame/military/components/menu-li-record.vue";
import {useUserRecentMenu} from "@/layouts/layoutFrame/military/hooks/useUserRecentMenu";

const {selActiveOneMenu}=useUserRecentMenu();
const props=defineProps({
  item:{}
})

</script>

<style type="text/css" lang="less">

</style>
